

<header>
    <div class="utilities">
        <span class="classification">RESTRICTED FR</span>
        <span class="profile">{{storage.get('oktaUser')?.firstName}}  {{storage.get('oktaUser')?.lastName}}</span>
        <a href="javascript:void(0);" class="logout"  (click)="logout()">Log Out</a>
    </div>
</header>